"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_ANSWER_TEXT_WORDS = exports.AnswerType = void 0;
var AnswerType;
(function (AnswerType) {
    AnswerType["SINGLE"] = "single";
    AnswerType["MULTI"] = "multi";
    AnswerType["CALCULATION"] = "calculation";
})(AnswerType = exports.AnswerType || (exports.AnswerType = {}));
exports.MAX_ANSWER_TEXT_WORDS = 500;
//# sourceMappingURL=answer.js.map